import Button from "../ui/Button";
import { Settings } from "lucide-react";
import LeadScoreCard from "../leads/LeadScoreCard";
import ChatboxSettingsCard from "./ChatboxSettingsCard";

import { useAuthStore } from "../../store/authStore";

export default function AgentConfigurations({
  openLeadScoreModal,
  openChatboxModal,
  onOpenSettings,
  agentDetails,
}) {
  const { user } = useAuthStore();
  const isAgent = user?.role === "agent";

  if(isAgent){
    return null;
  }

  return (
    <section className="agent-config-cont">
      <div className="d-flex justify-between align-center">
        <h2 className="primary">Configurations</h2>

        <Button variant="plain" onClick={onOpenSettings}>
          <Settings size={33} />
        </Button>
      </div>

      <section className="agent-config-grid">
        <LeadScoreCard
          onEdit={openLeadScoreModal}
          scoringConfig={agentDetails?.scoring_config}
        />
        <ChatboxSettingsCard
          onEdit={openChatboxModal}
          chatboxSettings={agentDetails?.settings}
        />
      </section>
    </section>
  );
}